import styled from 'styled-components';

import { RadiusConfig, Spacing } from 'enable-ui';

import { COLOR } from 'constants/color';

export const ClassFormContainer = styled.div`
  max-width: 800px;
`;

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: fit-content;
  padding: 12px 9px 13px;
  border-radius: ${RadiusConfig.sm}px;
  border: 1px solid ${COLOR.purpel['purpel-3']};
  background: ${COLOR.purpel['purpel-1']};
  margin-bottom: 16px;
  max-height: 40px;

  path {
    stroke: ${COLOR.purpel['purpel-6']};
  }
`;

export const EmptyAddContentContainer = styled(Spacing)`
  .button-container {
    path {
      stroke: ${COLOR.purpel['purpel-6']} !important;
    }

    p {
      font-size: 14px;
      font-weight: 600;
      line-height: calc(20 / 14);
      color: ${COLOR.purpel['purpel-6']};
    }
  }
`;

export const TitleContainer = styled(EmptyAddContentContainer)`
  display: flex;
  justify-content: space-between;

  .button-container {
    margin-top: 0;
  }
`;

export const TableContainer = styled.div`
  th {
    padding: 14px 16px;
  }

  td {
    padding: 19px 16px;
  }
`;
